import styled from 'styled-components';
import { DatePicker, Form, Select } from 'antd';
import { IRequestSMSPurchaseParams, ISummaryRequestSMSParams, RequestSMSPurchaseStatusOptions } from '../../../../interfaces/apis';
import Button from '../../../../../../components/Button';
import { useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import TopUpAmountReportModal, { TopUpAmountReportModalRef } from '../TopUpAmountReportModal';
import useGetAllStore from '../../../../services/hooks/useGetAllStore';

interface RequestSmsFilterProps {
  params?: IRequestSMSPurchaseParams;
  setParams?: (params: IRequestSMSPurchaseParams) => void;
  setSummaryParams?: (params: ISummaryRequestSMSParams) => void;
}

const RequestSmsFilter = ({ params, setParams, setSummaryParams }: RequestSmsFilterProps) => {
  const [form] = Form.useForm();
  const { data: listSalon } = useGetAllStore();
  const useTopUpAmountReportModalRef = useRef<TopUpAmountReportModalRef>(null);

  useEffect(() => {
    if (params) {
      form.setFieldsValue({
        page: params.page,
        shopId: params.shopId || '',
        startDate: params.startDate ? dayjs(params.startDate) : null,
        endDate: params.endDate ? dayjs(params.endDate) : null,
        status: params.status || undefined,
      });
    }
  }, [params]);

  const handleFinish = (values: any) => {
    setParams && setParams({ ...params, ...values });
    setSummaryParams && setSummaryParams(values);
  };

  return (
    <Container>
      <Form
        layout='vertical'
        className='styled-form'
        form={form}
        onFinish={handleFinish}
      >
        <Form.Item name='shopId' noStyle>
          <Select
            size='large'
            defaultValue={''}
            showSearch
            optionFilterProp='label'
            className='filter-select'
            style={{ flex: 1 }}
          >
            <Select.Option value={''} label={'All Salon - Zipcode'}>
              All Salon - Zipcode
            </Select.Option>
            {listSalon?.map((item: any) => (
              <Select.Option key={item.shopId} value={item.shopId} label={`${item.shopName} - ${item.zipCode}`}>
                {item.shopName} - {item.zipCode}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name='startDate' noStyle>
          <DatePicker style={{ width: '20%' }} format='MM-DD-YYYY' showTime={false} placeholder='Start date' />
        </Form.Item>
        <Form.Item name='endDate' noStyle>
          <DatePicker style={{ width: '20%' }} format='MM-DD-YYYY' showTime={false} placeholder='End date' />
        </Form.Item>
        <Form.Item name='status' noStyle>
          <Select
            options={RequestSMSPurchaseStatusOptions}
            placeholder='Select status'
            allowClear
            className='filter-select'
          />
        </Form.Item>
        <Button variant='SECONDARY' className='styled-button' htmlType='submit'>
          Search
        </Button>
        <Button
          variant='PRIMARY'
          icon='add'
          className='styled-button'
          onClick={() => useTopUpAmountReportModalRef.current?.open()}
        >
          Top Up
        </Button>
      </Form>
      <TopUpAmountReportModal
        ref={useTopUpAmountReportModalRef}
        onSuccess={() => {
          form.submit();
        }}
      />
    </Container>
  );
};

export default RequestSmsFilter;

const Container = styled.div`
  width: 100%;

  .styled-form {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;

    .ant-form-item {
      margin-bottom: 0;
    }

    .filter-select {
      width: 200px;
      height: 48px;
    }

    .styled-button {
      height: 48px;
    }
  }
`;
